<template>
  <component :is="tag" class="root" ref="root">
    <div ref="fg" :class="{ foreground: true }">
      <slot name="foreground"></slot>
    </div>
  </component>
</template>

<script>
export default {
  name: 'Scroller',
  props: {
    rootMargin: {
      default: '-50px',
      type: String
    },
    tag: {
      type: String,
      default: 'div'
    }
  },
  mounted() {
    this.io = new IntersectionObserver(this.onIO, {
      rootMargin: this.rootMargin
    })
    this.$slots.foreground[0].children
      .filter(child => child.elm && child.elm instanceof Element)
      .forEach((child, idx) => {
        this.sections[idx] = { elm: child.elm, isIntersecting: false }
        if (child.elm instanceof Element) this.io.observe(child.elm)
      })
    // this.onscroll()
  },
  methods: {
    onIO(changes) {
      const newSections = { ...this.sections }
      const updateSection = change => {
        const section = Object.entries(this.sections).find(([key, value]) => {
          return value.elm === change.target
        })
        newSections[section[0]].isIntersecting = change.isIntersecting
      }
      changes.forEach(updateSection)
      this.sections = newSections
    }
  },
  computed: {
    activeSection() {
      if (this.sections) {
        let lastActiveSection = -1
        Object.values(this.sections).forEach((section, idx) => {
          if (section.isIntersecting) lastActiveSection = idx
        })

        return lastActiveSection
      }
      return -1
    }
  },
  watch: {
    activeSection(activeSection) {
      this.$emit('change', activeSection)
    }
  },
  data() {
    return {
      stopped: false,
      isSticky: false,
      style: {},
      sections: {}
    }
  }
}
</script>

<style scoped>
</style>
